
import {
  IPlanStandardCalculatorClientExtension,
  IPlanStandardCalculatorClientExtensionProvider
} from "../../PA.TPM.Core/PA.TPM.IF.TPM.Plan.Aspects";
import * as _ from 'lodash'
import {ASync} from "../../PA.Core/Basic/ASync";
import {PlanStandardCalculatorExtDefault} from "./PlanStandardCalculatorExtDefault";
import {PSCHainSimple} from "./PSCHainSimple";
import {PSCHainAdvanced} from "./PSCHainAdvanced";

let availableExtensions: IPlanStandardCalculatorClientExtension[] = [
  PlanStandardCalculatorExtDefault,
  PSCHainSimple,
  PSCHainAdvanced
]


let PlanStandardCalculatorExtProvider: IPlanStandardCalculatorClientExtensionProvider = {


  get PlanStandardCalculatorExtensions(): Promise<IPlanStandardCalculatorClientExtension[]> {
    return ASync.resolve( _.clone(availableExtensions))
  },

  getPlanStandardCalculatorExtension(anExtensionId: string): Promise<IPlanStandardCalculatorClientExtension> {

    return new Promise<IPlanStandardCalculatorClientExtension>((resolve, error) => {


      _.forEach(availableExtensions, (anExt) => {
        if(anExt.id == anExtensionId){
          resolve(anExt)
          return
        }
      })

      resolve(undefined)
    })
  }

}

export {PlanStandardCalculatorExtProvider}